import { render, staticRenderFns } from "./AssessmentDepositoryEdit.vue?vue&type=template&id=3c5fc5d6&scoped=true"
import script from "./AssessmentDepositoryEdit.vue?vue&type=script&lang=js"
export * from "./AssessmentDepositoryEdit.vue?vue&type=script&lang=js"
import style0 from "./AssessmentDepositoryEdit.vue?vue&type=style&index=0&id=3c5fc5d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5fc5d6",
  null
  
)

export default component.exports